import React, { useState, useEffect } from "react";
import "./ShopPayment.css";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import Coins from "../../../Components/Coins/Coins";
import Alert from "../../../Components/Alert/Alert";
import BottomBar from "../../../Components/BottomBar/BottomBar";
import MailIcon from "../../../Components/MailIcon/MailIcon";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../AuthContext";
import Axios from "axios";
import { MdClose } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import useCart from "../../../Hooks/useCart";
import { SlArrowDown } from "react-icons/sl";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import { useBaseUrl } from "../../../ApiContext";

export default function ShopPayment() {
  const location = useLocation();
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const { cart, setCart } = useCart(userToken);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [address, setAddress] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [activeEditAddress, setActiveEditAddress] = useState(false);
  const [textareaVal, setTeaxtareaVal] = useState("");
  const [addressIsComplete, setAddressIsComplete] = useState(false);
  const [shipments, setShipments] = useState(null);
  const [showShipments, setShowShipments] = useState(false);

  const fetchCart = async () => {
    try {
      const response = await Axios.get(`${baseUrl}/cart`, {
        headers: {
          Authorization: `Token ${userToken}`,
        },
      });
      setCart(response.data);
    } catch (error) {
      console.log("Error during getting cart data", error);
    }
  };

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const showAlertHandler = () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    setAlertText("به زودی");
  };

  const handleHideModal = () => {
    setShowModal(false);
  };

  const handleShowModal = () => {
    setShowModal(true);
    setTeaxtareaVal(address);
  };

  const handlePayment = async () => {
    if (addressIsComplete) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      setAlertText("در حال انتقال به صفحه پرداخت...");
      try {
        const response = await Axios.post(
          `${baseUrl}/payment/buy?cart=1`,
          {},
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        const url = response.data.url;
        if (url && url.includes("zarinpal")) {
          window.location.href = url;
        }
      } catch (error) {
        console.log("Error during opening payment page", error);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("خطا در برقراری ارتباط");
      }
    } else {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      setAlertText("آدرس خود را وارد کنید");
    }
  };

  const handleShowShipments = async () => {
    setShowShipments(true);
    try {
      const response = await Axios.get(`${baseUrl}/shop/shipments`, {
        headers: {
          Authorization: `Token ${userToken}`,
        },
      });
      setShipments(response.data.shipments);
    } catch (error) {
      console.log("Error during getting shipments", error);
    }
  };

  const handleHideShipments = () => {
    setShowShipments(false);
  };

  const fetchAddress = async () => {
    try {
      const response = await Axios.get(`${baseUrl}/shop/address`, {
        headers: {
          Authorization: `Token ${userToken}`,
        },
      });
      setAddress(response.data.address);
      setAddressIsComplete(response.data.is_complete);
    } catch (error) {
      console.log("Error during getting address", error);
    }
  };

  const handleChangeAddress = async () => {
    if (activeEditAddress) {
      if (textareaVal) {
        try {
          const response = await Axios.post(
            `${baseUrl}/shop/address`,
            { address: textareaVal },
            {
              headers: {
                Authorization: `Token ${userToken}`,
              },
            }
          );
          fetchAddress();
          setShowModal(false);
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
            setActiveEditAddress(false);
          }, 2000);
          setAlertText("آدرس ثبت شد");
        } catch (error) {
          console.log("Error during posting address", error);
        }
      } else {
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("آدرس نباید خالی باشد");
      }
    } else {
      setActiveEditAddress(true);
    }
  };

  useEffect(() => {
    if (cart && cart.shipment === null) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      setAlertText("لطفاروش ارسال خود را انتخاب کنید");
    }
  }, [cart]);

  useEffect(() => {
    if (userToken) {
      fetchAddress();
    }
  }, [baseUrl, userToken]);

  const handleShipmentSelection = async (shipment) => {
    try {
      const response = await Axios.post(
        `${baseUrl}/cart/add-shipment/${shipment.slug}`,
        {},
        {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        }
      );
      if (response.status === 200) {
        setShowShipments(false);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("روش ارسال انتخاب شد");
        fetchCart();
      }
    } catch (error) {
      console.log("Error during adding shipment", error);
    }
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay productContainer">
        <div className="pageWrapper cartOverlay cartPaymentOverlay">
          <div className="pageHeader centeredFlex">
            <div className="shopPaymentHeaderRight centeredFlex">
              <BackBtn />
              <div className="shopMailCoins centeredFlex">
                <MailIcon loc={location.pathname} />
                <Coins onShowAlert={showAlertHandler} />
              </div>
            </div>
            <div className="shopPaymentHeaderLeft centeredFlex">
              <img
                src="/images/ic_menu.svg"
                alt="menu"
                className="menuIcon"
                onClick={hamburgerMenuHandler}
              />
            </div>
          </div>
          <div className="shopPaymentField horizontalBorder">
            <p className="shopPaymentTitle">آدرس تحویل سفارش:</p>
            <div className="shopPaymentAction centeredFlex">
              <p>{addressIsComplete ? address : "آدرسی یافت نشد"}</p>
              <button type="button" onClick={handleShowModal}>
                ویرایش
              </button>
            </div>
          </div>
          <div className="shopPaymentField">
            <p className="shopPaymentTitle">هزینه ارسال سفارش:</p>
            <div className="shopPaymentAction centeredFlex">
              {cart && (
                <p>
                  {cart.shipment
                    ? `${
                        cart.shipment.name
                      }, هزینه ارسال: ${cart.shipment.price.toLocaleString()} تومان `
                    : "روش ارسال انتخاب نشده است"}
                </p>
              )}
              <button type="button" onClick={handleShowShipments}>
                روش ارسال
              </button>
            </div>
          </div>
          <div className="cartBottom horizontalBorder centeredFlex">
            <div className="totalPrice centeredFlex">
              <p>مجموع سبد خرید</p>
              <p>
                {cart && cart.shipment
                  ? (cart.total_price + cart.shipment.price).toLocaleString()
                  : cart && !cart.shipment
                  ? cart.total_price.toLocaleString()
                  : "0"}{" "}
                تومان
              </p>
            </div>
            {cart && cart.shipment && (
              <button
                onClick={handlePayment}
                className="confirmAndNextBtn nextQuestion"
              >
                پرداخت
              </button>
            )}
          </div>
        </div>
        <Modal
          show={showModal}
          onHide={handleHideModal}
          className="shopPaymentModal"
        >
          <Modal.Header className="shopPaymentModalHeader centeredFlex">
            <MdClose
              className="specificClose shopPaymentClose"
              onClick={handleHideModal}
            />
          </Modal.Header>
          <Modal.Body className="shopPaymentModalBody">
            <p>آدرس تحویل سفارش:</p>
            {(address || (!address && activeEditAddress)) && (
              <textarea
                value={textareaVal}
                onChange={(e) => setTeaxtareaVal(e.target.value)}
                placeholder="آدرس خود را وارد کنید"
                readOnly={!activeEditAddress}
              ></textarea>
            )}
          </Modal.Body>
          <Modal.Footer className="shopPaymentModalFooter">
            <button
              onClick={handleChangeAddress}
              style={
                activeEditAddress
                  ? { backgroundColor: "var(--green)" }
                  : { backgroundColor: "var(--orange)" }
              }
            >
              {activeEditAddress ? "ثبت آدرس" : "ثبت / تغییر آدرس"}
            </button>
          </Modal.Footer>
        </Modal>
        <Alert alertText={alertText} showAlert={showAlert} />
        <BottomBar />
        {showShipments && (
          <>
            <div
              className="shipmentsOverlay"
              onClick={handleHideShipments}
            ></div>
            <div className="shipments">
              <div className="shipmentsLine"></div>
              <SlArrowDown
                className="shipmentsIcon"
                onClick={handleHideShipments}
              />
              <h4>انتخاب روش ارسالی</h4>
              {shipments &&
                shipments.length > 0 &&
                shipments.map((shipment) => (
                  <div
                    className="shipment centeredFlex horizontalBorder"
                    key={shipment.slug}
                    onClick={() => handleShipmentSelection(shipment)}
                  >
                    <div className="centeredFlex shipmentBy">
                      <span>ارسال از طریق:</span>
                      <p>{shipment.name}</p>
                    </div>
                    <div className="centeredFlex shipmentCost">
                      <span>هزینه ارسال:</span>
                      <p>{shipment.price.toLocaleString()}</p>
                    </div>
                  </div>
                ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
